import { render, staticRenderFns } from "./RecentProjectsEmptyItem.vue?vue&type=template&id=5b5945a2"
import script from "./RecentProjectsEmptyItem.vue?vue&type=script&lang=ts"
export * from "./RecentProjectsEmptyItem.vue?vue&type=script&lang=ts"
import style0 from "./RecentProjectsEmptyItem.vue?vue&type=style&index=0&id=5b5945a2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports